// The closing card's one status line (Antonin, 19 Oct: "what is the green bar under Wrap up? Merge it with the bottom status"): the
// wrap-up steps, each a StatusGlyph and its label (never colour alone: a done step is a check, a pending one a hollow circle):
//   ✓ ePrescription · ✓ Orders sent · ✓ Signed by Crisanto Rivera · 19 Oct 2026, 19:40
//   ○ ePrescription pending · ○ Orders not sent · ○ Not signed        (before the sign; the Sign note button follows it)
// Steps: ePrescription only when the host offers it; Orders only for a non-nurse; the sign step always.
import { GlyphText } from '@/shared/ui/components/status-glyph';

export interface NoteStatusLineProps {
  /** `status.orderSent` of the Wrap-up slice. Absent → the Orders step is left out. */
  orderSent?: boolean;
  /** Draw the Orders step (a non-nurse, and the host has the slice). */
  showOrders: boolean;
  /** The ePrescription step: absent → not offered (nothing drawn). */
  ePrescription?: { synced: boolean };
  providerSigned: boolean;
  signedBy?: string;
  /** The sign time as the page formats it; absent → the name alone. */
  signedWhen?: string;
}

export function NoteStatusLine({ orderSent, showOrders, ePrescription, providerSigned, signedBy, signedWhen }: NoteStatusLineProps) {
  const steps: { id: string; done: boolean; label: string }[] = [];
  if (ePrescription) steps.push({ id: 'eprescription', done: ePrescription.synced, label: ePrescription.synced ? 'ePrescription' : 'ePrescription pending' });
  if (showOrders) steps.push({ id: 'orders', done: !!orderSent, label: orderSent ? 'Orders sent' : 'Orders not sent' });
  steps.push({
    id: 'sign',
    done: providerSigned,
    label: providerSigned ? [signedBy ? `Signed by ${signedBy}` : 'Signed', signedWhen].filter(Boolean).join(' · ') : 'Not signed',
  });
  return (
    <span data-slot="note-status-line">
      {steps.map((s) => (
        <GlyphText key={s.id} kind={s.done ? 'done' : 'empty'} data-step={s.id} data-state={s.done ? 'done' : 'pending'}>
          {s.label}
        </GlyphText>
      ))}
    </span>
  );
}
